<p class="error-login"
    *ngIf="errorMessage">
    <mat-icon fontSet="material-symbols-sharp"
        class="material-symbols-sharp_bold error-login__icon">
        cancel
    </mat-icon>
    {{errorMessage}}
</p>